<template>
  <span class="MdSpn"
    :class="[
      sizeClass,
      weightClass,
      styleClass,
      decorationClass,
      hoverPath === parentPath + 'span' ? 'on-hover' : '',
      !isAdmin && editPath === parentPath + 'span' ? 'on-edit' : ''
    ]"
    :style="styles"
    @click="selectNode(span, parentPath + 'span')"
  >
    {{ span.text }}
  </span>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageSpan } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class Span extends Vue {
  @Prop()
  span!: IFlexMessageSpan

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  get sizeClass() {
    if (this.span.size === 'xxs') {
      return 'ExXXs'
    } else if (this.span.size === 'xs') {
      return 'ExXs'
    } else if (this.span.size === 'sm') {
      return 'ExSm'
    } else if (this.span.size === 'md') {
      return 'ExMd'
    } else if (this.span.size === 'lg') {
      return 'ExLg'
    } else if (this.span.size === 'xl') {
      return 'ExXl'
    } else if (this.span.size === 'xxl') {
      return 'ExXXl'
    } else if (this.span.size === '3xl') {
      return 'Ex3Xl'
    } else if (this.span.size === '4xxl') {
      return 'Ex4Xl'
    } else if (this.span.size === '5xl') {
      return 'Ex5Xl'
    }
    return ''
  }

  get weightClass() {
    if (this.span.weight === 'regular') {
      return 'ExWR'
    } else if (this.span.weight === 'bold') {
      return 'ExWB'
    }
    return ''
  }

  get styleClass() {
    if (this.span.style === 'normal') {
      return 'ExFntStyNml'
    } else if (this.span.weight === 'italic') {
      return 'ExFntStyIt'
    }
    return ''
  }

  get decorationClass() {
    if (this.span.decoration === 'none') {
      return 'ExTxtDecNone'
    } else if (this.span.decoration === 'underline') {
      return 'ExTxtDecUl'
    } else if (this.span.decoration === 'line-through') {
      return 'ExTxtDecLt'
    }
    return ''
  }

  get styles() {
    const spanStyles: Record<string, string|number|undefined> = {}

    spanStyles.color = this.span.color
    spanStyles.cursor = 'pointer'

    return spanStyles
  }

  get currentNodePath() {
    return this.parentPath + 'span'
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  mounted() {
    this.$emit('initListNode', this.currentNodePath)
  }
}
</script>

<style scoped lang="scss">

</style>
